import { FieldError, MUIIcon, Spinner } from "../../../widgets"
import { useSendEmailOTPMutation, useVerifyOTPMutation } from "./services"

import { IEntity } from "../../../base/types"
import { useFormikContext } from "formik"
import { useState } from "react"

export const OtpVerifiedEMail = ({ fieldId, verifiedFieldId }: {
    fieldId: string,
    verifiedFieldId: string,
}) => {
    const [otp, setOTP] = useState<string>('')
    const [requestedEmail, setRequestedEmail] = useState<string>('')
    const [requested, setRequested] = useState<boolean>(false)
    const { errors, values, setFieldValue, setFieldTouched, setFieldError } = useFormikContext<IEntity>() || {}

    const [sendOTP, { isLoading: sending }] = useSendEmailOTPMutation()
    const [verifyOTP, { isLoading: verifying }] = useVerifyOTPMutation()

    const handleBlur = () => {
        setFieldTouched(fieldId, true)
        handleSendOTP();
    }

    const handleEMailChange = (email: string) => {
        setFieldValue(verifiedFieldId, false)
        setRequested(false);
        setOTP('')

        setFieldValue(fieldId, email)
    }

    const handleSendOTP = () => {
        const emailAddress = values[fieldId]
        if (!emailAddress) return;

        setFieldError(verifiedFieldId, undefined)
        sendOTP({ identifier: emailAddress })
            .unwrap()
            .then(() => {
                setRequestedEmail(emailAddress)
                setFieldValue(verifiedFieldId, false)
                setRequested(true)
            })
    }

    const handleVerifyOTP = () => {
        const emailAddress = values[fieldId]
        if (!emailAddress || !requested || !otp || requestedEmail !== emailAddress)
            return;

        setFieldError(verifiedFieldId, undefined)

        verifyOTP({ identifier: emailAddress, otp })
            .unwrap()
            .then((result) => {
                setFieldValue(verifiedFieldId, result.verified)
                if (!result.verified) {
                    setFieldError(verifiedFieldId, 'OTP entered is not correct.')
                }
            })
    }

    const { [fieldId]: emailAddress, [verifiedFieldId]: emailVerified } = values;

    return <>
        <div className="d-flex flex-row flex-wrap gap-2">
            <div className="flex-fill d-flex align-items-center gap-2">
                <input
                    className="form-control form-control-sm"
                    type="email"
                    value={emailAddress || ''}
                    readOnly={sending}
                    onBlur={handleBlur}
                    onChange={(e) => handleEMailChange(e.target.value)}
                />
                {(emailVerified) && <>
                    <MUIIcon iconName="VerifiedOutlined" className=" text-primary" />
                </>}
            </div>
            {(!emailVerified) && <>
                <div className="d-flex flex-row mw-300px align-items-center gap-2">
                    <div className="flex-fill">
                        <input
                            className="form-control form-control-sm fw-semibold"
                            disabled={!emailAddress}
                            type="text"
                            placeholder="Enter OTP"
                            value={otp || ''}
                            onBlur={handleVerifyOTP}
                            onChange={(e) => setOTP(e.target.value)}
                        />
                    </div>
                    <div className="d-flex flex-row gap-2">
                        <button
                            type="button"
                            disabled={!emailAddress || sending || !!otp}
                            onClick={() => handleSendOTP()}
                            className="btn btn-sm btn-primary py-1 fw-semibold">
                            <div className="d-flex align-items-center gap-2">
                                <label>Resend</label>
                                {(!sending) ? <>
                                    <MUIIcon iconName="SendOutlined" className="fs-7" />
                                </> : <>
                                    <Spinner show={true} />
                                </>}
                            </div>
                        </button>
                        <button
                            type="button"
                            disabled={!emailAddress || !requested || !otp}
                            onClick={() => handleVerifyOTP()}
                            className="btn btn-sm btn-primary py-1 fw-semibold">
                            <div className="d-flex align-items-center gap-2">
                                {(!verifying) ? <>
                                    <MUIIcon iconName="CheckOutlined" className="fs-7" />
                                </> : <>
                                    <Spinner show={true} />
                                </>}
                                <label>Verify</label>
                            </div>
                        </button>
                    </div>
                </div>
            </>}
        </div>
        <FieldError show={!!errors[verifiedFieldId]} message={errors[verifiedFieldId] as string} />
    </>
}